import React, { Suspense } from 'react';
import PageLoader from '../components/common/PageLoader';
import AdminRoute from '../components/AdminRoute';

export function withSuspense(element) {
  return <Suspense fallback={<PageLoader />}>{element}</Suspense>;
}

export function wrapAdmin(Page, props) {
  const page = props ? <Page {...props} /> : <Page />;
  return withSuspense(<AdminRoute>{page}</AdminRoute>);
}
